import type { PatchNotesEntry } from './patchNotes';

export const GENERATED_PATCH_NOTES: PatchNotesEntry[] = [
  {
    "version": "1.0.5",
    "title": "Patchnotes 1.0.5",
    "file": "/patchnotes/1.0.5.md"
  },
  {
    "version": "1.1.0",
    "title": "Patchnotes 1.1.0",
    "file": "/patchnotes/1.1.0.md"
  },
  {
    "version": "1.1.1",
    "title": "Patchnotes 1.1.1",
    "file": "/patchnotes/1.1.1.md"
  },
  {
    "version": "1.2.0",
    "title": "Patchnotes 1.2.0",
    "file": "/patchnotes/1.2.0.md"
  },
  {
    "version": "2.1.0",
    "title": "Patchnotes 2.1.0",
    "file": "/patchnotes/2.1.0.md"
  }
];
